import { Component } from 'react'

import StyledAction from './StyledAction'

interface OpenUrlActionProps {
  actionHandler?(...args: unknown[]): unknown
  color?: string
  disabled?: boolean
  format?: 'normal' | 'outline'
  orientation?: string
  title: string
  type?: string
  url?: string
}

class OpenUrlAction extends Component<OpenUrlActionProps> {
  static displayName = 'OpenUrlAction'
  static defaultProps = {
    title: '',
    color: 'link',
    format: 'normal'
  }

  constructor(props: any) {
    super(props)

    this.actionHandler = this.actionHandler.bind(this)
  }

  actionHandler(e: any) {
    const { actionHandler, url, type, title } = this.props
    e.stopPropagation()
    // @ts-expect-error
    actionHandler(type, title, { url })
  }

  render() {
    const { title, orientation, color, format, disabled } = this.props
    return (
      <StyledAction
        // @ts-expect-error
        orientation={orientation}
        color={color}
        format={format}
        onClick={this.actionHandler}
        disabled={disabled}
      >
        {title}
      </StyledAction>
    )
  }
}

export default OpenUrlAction
